module.exports = __webpack_public_path__ + "static/media/EGLD-BNB.69564d46.svg";